import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

export const Wrapper = styled(Box)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  background: "white",
  bgcolor: "background.paper",
  borderRadius: 4,
  padding: "16px 8px 16px 16px",
}));

export const ModalCloseButton = styled(IconButton)(() => ({
  marginLeft: "auto",
}));
